import { useEffect, useRef } from 'react';

// Runs the (latest) callback once, on unmount. Uses a ref so it never captures a
// stale closure. (Local replacement for react-use/lib/useUnmount.)
export default function useUnmount(fn: () => void) {
  const fnRef = useRef(fn);

  // Keep the ref pointing at the latest callback (updated in an effect, not during
  // render — react-hooks/refs).
  useEffect(() => {
    fnRef.current = fn;
  });

  useEffect(
    () => () => {
      fnRef.current();
    },
    [],
  );
}
